import * as base from "api/com";
import {
  setLogin
} from 'router';
import router from "router";
import * as storage from "utils/sessionStorage";
import {
  Message
} from 'element-ui'


const common = {
  state: {
    name: '校餐卫士web端',
    userType: 'admin',
    user: {},
    baseUrl: '',
    dictTree: []

  },
  mutations: {
    SET_NAME: (state, name) => state.name = name,
    SET_USER_TYPE: (state, type) => state.userType = type,
    SET_USER: (state, user) => state.user = user,
    SET_BASE_URL: (state, baseUrl) => state.baseUrl = baseUrl,
    SET_DICT_TREE: (state, dictTree) => state.dictTree = dictTree,
  },
  actions: {

    getName: ({
      commit
    }) => {
      return new Promise((resolve, reject) => {
        commit("SET_NAME", 'ddd');
      })
    },
    /**
     * 用户登录 ,登录成功 返回数据令牌 和 刷新令牌
     */
    login: ({
      commit
    }, loginDto) => {
      return new Promise((resolve, reject) => {
        base.login(loginDto).then(results => {
          if (results.code == 200) {
            setLogin(true,1);
            commit("SET_USER_TYPE", loginDto.type);
            storage.setCookie('SET_USER_TYPE', loginDto.type);
            // 设置数据令牌到Cookie
            resolve(results);
          } else {
            if (results.code != 4017 && results.code != 4018) {
              if (loginDto.type == 'admin') {
                Message.error({
                  message: results.msg + ',如果你不是管理员，请切换职工登录'
                })
              } else {
                Message.error({
                  message: results.msg + ',如果你不是职工，请切换管理员登录'
                })
              }
            } else {
              Message.error({
                message: results.msg
              })
            }
            reject(results);
          }
        })
      });
    },
    /**
     * 前端登出
     */
    logout: ({
      commit,
      state
    }) => {
      let type = storage.getCookie('SET_USER_TYPE')
      base.logout(type).then((data) => {
        if (data.code == 200) {
          setLogin(false);
          commit('SET_USER', {});
          commit("SET_DICT_TREE", []);
          if(storage.getData('loginType') && storage.getData('loginType') === 'merchant'){
            router.push({
              name: 'login1'
            })
          }else{
            router.push({
              name: 'login'
            })
          }
          
          // 删除
        }
      })
    },
    /**
     * 拉取当前登录用户信息,含有 用户基本信息, 菜单
     */
    getInfo: ({
      commit,
      state
    }, ) => {
      return new Promise(async (resolve, reject) => {
        let type = storage.getCookie('SET_USER_TYPE')?storage.getCookie('SET_USER_TYPE'):'admin'
        await base.getUserInfo(type).then(user => {
          if (user.code == 200) {
            commit("SET_USER", user.data);
          }
        })

        await base.getBaseData().then(base => {
          if (base.code == 200) {
            commit("SET_BASE_URL", base.data.baseUrl);
            commit("SET_DICT_TREE", base.data.dictTree);
          }
        })

        resolve();
      })
    },
  }
}

export default common;